import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=4d53d900&scoped=true"
import script from "./CustomerDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d53d900",
  null
  
)

export default component.exports